var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("a-collapse", {
    attrs: {
      activeKey: _vm.activeKey
    },
    on: {
      change: _vm.collapseChange
    }
  }, _vm._l(_vm.collapses, function (item) {
    return _c("a-collapse-panel", {
      key: item.key,
      attrs: {
        header: _vm.$t(item.title)
      }
    }, [_vm.tabKey === "INTERNAL_MAIL" ? _c("mailForm", {
      ref: `${_vm.tabKey}${item.key}`,
      refInFor: true,
      attrs: {
        type: _vm.tabKey,
        language: item.key,
        item: _vm.datas[item.key],
        sceneListId: _vm.sceneListId,
        variables: _vm.variables
      }
    }) : _vm.tabKey === "NOTE" ? _c("message-form", {
      ref: `${_vm.tabKey}${item.key}`,
      refInFor: true,
      attrs: {
        type: _vm.tabKey,
        language: item.key,
        item: _vm.datas[item.key],
        sceneListId: _vm.sceneListId,
        allMessageList: _vm.allMessageList,
        variables: _vm.variables
      }
    }) : _vm.tabKey === "EMAIL" ? _c("emailForm", {
      ref: `${_vm.tabKey}${item.key}`,
      refInFor: true,
      attrs: {
        type: _vm.tabKey,
        language: item.key,
        item: _vm.datas[item.key],
        sceneListId: _vm.sceneListId,
        variables: _vm.variables
      }
    }) : _vm._e()], 1);
  }), 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };